import { FC, ReactNode } from 'react'
import styled from 'styled-components'

interface IFFilterFieldWrapperProps {
  label: ReactNode
  className?: string
}

const FilterFieldWrapper: FC<IFFilterFieldWrapperProps> = ({
  label,
  className,
  children,
}) => {
  return (
    <StyledWrapper className={className}>
      <div className="field-label">{label}</div>
      {children}
    </StyledWrapper>
  )
}

export default FilterFieldWrapper

const StyledWrapper = styled.div`
  .field-label {
    font-size: 12px;
    color: ${(props) => props.theme.color.text_3};
    margin-bottom: 11px;
  }
`
